import React from 'react';
// import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import TopicActionButton from '../TopicActionButton';
import {ProfileThumb} from '../../Common/CardComponents';
// import {Icon} from '../../Common/Icon';

import cx from '../../../styles';

const TopicDescriptionComponent = ({topic, t, match}) => {

    return (
        <div className={cx("topic-description-component")}>
            <div>
                <ProfileThumb img={topic.image ? topic.image : ""} size="large" altName={`${topic.name} icon`} />
            </div>

            <section className={cx("post-section")}>
                <div className={cx("post-section-header")}>
                    <div className={cx("left")}>
                        <div className={cx("author-name")}>
                            <h1>{topic.name}</h1>
                            <p>{topic.total_members} {t('topic_follower')}</p>
                        </div>
                    </div>

                    <div className={cx("right")}>
                        <TopicActionButton topic={topic} match={match} shouldRefreshTopicList={false}/>
                    </div>
                </div>

                <div className={cx("post-section-body")}>
                    <div>{topic.description}</div>
                </div>
            </section>
        </div>
    );
}

export default translate()(TopicDescriptionComponent);
